import { all, call, put, takeEvery } from 'redux-saga/effects';

import {
    UPDATE_WELLNESS_SLEEP_NOTE,
    UPDATE_WELLNESS_SLEEP_NOTE_START,
    UPDATE_WELLNESS_SLEEP_NOTE_SUCCESS,
    UPDATE_WELLNESS_SLEEP_NOTE_FAIL,
    FETCH_WELLNESS_DAILY_SLEEP_DATA,
    FETCH_WELLNESS_DAILY_SLEEP_DATA_FETCHING,
    FETCH_WELLNESS_DAILY_SLEEP_DATA_SUCCESS,
    FETCH_WELLNESS_DAILY_SLEEP_DATA_FAIL,
    UPDATE_SLEEP_DTO,
    UPDATE_SLEEP_DTO_SUCCESS,
    UPDATE_SLEEP_DTO_FAIL,
    UPDATE_WELLNESS_SLEEP_WINDOW,
    UPDATE_WELLNESS_SLEEP_WINDOW_SUCCESS,
    UPDATE_WELLNESS_SLEEP_WINDOW_FAIL
} from 'actions/ActionTypes';
import { fetchMergedSummarySaga } from 'sagas/dailySummarySagas';
import * as UrlUtil from 'utils/UrlUtil';
import { gcApi } from '../config/axios';

// Workers
export function* fetchDailySleepDataSaga(action) {
    const { displayName, calendarDate, nonSleepBufferMinutes } = action;

    const qsObject = {
        date: calendarDate
    };

    if (nonSleepBufferMinutes) {
        qsObject.nonSleepBufferMinutes = nonSleepBufferMinutes;
    }

    const queryParams = UrlUtil.toQueryString(qsObject);

    try {
        yield put({
            type: FETCH_WELLNESS_DAILY_SLEEP_DATA_FETCHING,
            displayName: displayName,
            calendarDate: calendarDate
        });

        const response = yield call(
            gcApi.get,
            `/wellness-service/wellness/dailySleepData/${displayName}${queryParams}`
        );

        yield put({
            type: FETCH_WELLNESS_DAILY_SLEEP_DATA_SUCCESS,
            dailySleepData: response.data,
            displayName: displayName,
            calendarDate: calendarDate
        });
    } catch (e) {
        yield put({
            type: FETCH_WELLNESS_DAILY_SLEEP_DATA_FAIL,
            dailySleepData: {},
            displayName: displayName,
            calendarDate: calendarDate
        });
    }
}

export function* updateSleepDTO(action) {
    try {
        const newSleepDTO = action.newSleepDTO;
        const response = yield call(gcApi.put, `/wellness-service/wellness/dailySleep/${newSleepDTO.id}`, newSleepDTO);

        yield put({
            type: UPDATE_SLEEP_DTO_SUCCESS,
            sleepDTO: response.data
        });

        return response;
    } catch (e) {
        yield put({
            type: UPDATE_SLEEP_DTO_FAIL
        });
    }
}

export function* updateSleepWindow(action) {
    try {
        const newSleepDTO = action.newSleepDTO;
        const response = yield call(updateSleepDTO, { newSleepDTO });

        if (response.status === 200) {
            const { displayName, calendarDate, nonSleepBufferMinutes } = action;
            yield all([
                call(fetchDailySleepDataSaga, { displayName, calendarDate, nonSleepBufferMinutes }),
                call(fetchMergedSummarySaga, { displayName, calendarDate })
            ]);
        } else {
            yield put({
                type: UPDATE_WELLNESS_SLEEP_WINDOW_FAIL
            });
        }

        yield put({
            type: UPDATE_WELLNESS_SLEEP_WINDOW_SUCCESS
        });
    } catch (e) {
        yield put({
            type: UPDATE_WELLNESS_SLEEP_WINDOW_FAIL
        });
    }
}

export function* updateSleepNote(action) {
    const { userNote, displayName, calendarDate } = action;

    try {
        yield put({
            type: UPDATE_WELLNESS_SLEEP_NOTE_START,
            userNote,
            displayName,
            calendarDate
        });

        const response = yield call(gcApi.put, `wellness-service/wellness/dailySleep/${calendarDate}/note`, {
            userNote
        });

        yield put({
            type: UPDATE_WELLNESS_SLEEP_NOTE_SUCCESS,
            userNote: response.data
        });
    } catch (e) {
        yield put({
            type: UPDATE_WELLNESS_SLEEP_NOTE_FAIL,
            displayName,
            calendarDate
        });
    }
}

// Watchers

export const sleepSagas = [
    takeEvery(FETCH_WELLNESS_DAILY_SLEEP_DATA, fetchDailySleepDataSaga),
    takeEvery(UPDATE_SLEEP_DTO, updateSleepDTO),
    takeEvery(UPDATE_WELLNESS_SLEEP_WINDOW, updateSleepWindow),
    takeEvery(UPDATE_WELLNESS_SLEEP_NOTE, updateSleepNote)
];
